import type {Quote} from './schemas'

export function quoteNumber(quoteId: string): string {
    return quoteId.slice(0, 8).toUpperCase()
}

export function quoteLabel(quote: {id: string; name: string | null}): string {
    const name = quote.name?.trim()
    return name ? `"${name}"` : quoteNumber(quote.id)
}

export function quoteEmailBlockedReason(
    savedQuote: Pick<Quote, 'status' | 'customerContact' | 'createdByName' | 'archivedAt'>,
    {
        viewOnly,
        draftContactId,
        unsavedChanges = false,
    }: {viewOnly: boolean; draftContactId: string | null; unsavedChanges?: boolean},
): string | null {
    if (viewOnly) {
        return `Only ${savedQuote.createdByName ?? 'the rep'} or a manager can email this quote`
    }
    if (savedQuote.archivedAt != null) {
        return 'Archived quotes cannot be emailed'
    }
    if (savedQuote.status === 'rejected' || savedQuote.status === 'voided') {
        return `A ${savedQuote.status} quote cannot be emailed`
    }

    const contact = savedQuote.customerContact
    if ((contact?.id ?? null) !== draftContactId) {
        return 'Customer contact has changed. Save the quote first'
    }
    if (unsavedChanges) {
        return 'Save your changes first'
    }
    if (contact == null) {
        return 'Customer contact is required'
    }
    if (!contact.email?.trim()) {
        return `${contact.name} has no email address. Add one on the customer page`
    }

    return null
}
